import { OPEN_SHIFT_REQUEST_TYPES } from "../../constants/openShiftRequestTypes";

export const isOpenShiftRequest = (type?: string) => OPEN_SHIFT_REQUEST_TYPES.includes(type ?? "");
